import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Site\DeleteLocationBySiteIdController::deleteMethod
* @see app/Http/Controllers/Site/DeleteLocationBySiteIdController.php
* @route '/api/site/{site}/{location}'
*/
export const deleteMethod = (args: { site: string | number | { id: string | number }, location: string | number | { id: string | number } } | [site: string | number | { id: string | number }, location: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/site/{site}/{location}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Site\DeleteLocationBySiteIdController::deleteMethod
* @see app/Http/Controllers/Site/DeleteLocationBySiteIdController.php
* @route '/api/site/{site}/{location}'
*/
deleteMethod.url = (args: { site: string | number | { id: string | number }, location: string | number | { id: string | number } } | [site: string | number | { id: string | number }, location: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            site: args[0],
            location: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
        location: typeof args.location === 'object'
        ? args.location.id
        : args.location,
    }

    return deleteMethod.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace('{location}', parsedArgs.location.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Site\DeleteLocationBySiteIdController::deleteMethod
* @see app/Http/Controllers/Site/DeleteLocationBySiteIdController.php
* @route '/api/site/{site}/{location}'
*/
deleteMethod.delete = (args: { site: string | number | { id: string | number }, location: string | number | { id: string | number } } | [site: string | number | { id: string | number }, location: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Site\DeleteLocationBySiteIdController::undo
* @see app/Http/Controllers/Site/DeleteLocationBySiteIdController.php
* @route '/api/site/undo-delete/{site}/{location}'
*/
export const undo = (args: { site: string | number | { id: string | number }, location: string | number } | [site: string | number | { id: string | number }, location: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: undo.url(args, options),
    method: 'delete',
})

undo.definition = {
    methods: ["delete"],
    url: '/api/site/undo-delete/{site}/{location}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Site\DeleteLocationBySiteIdController::undo
* @see app/Http/Controllers/Site/DeleteLocationBySiteIdController.php
* @route '/api/site/undo-delete/{site}/{location}'
*/
undo.url = (args: { site: string | number | { id: string | number }, location: string | number } | [site: string | number | { id: string | number }, location: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            site: args[0],
            location: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
        location: args.location,
    }

    return undo.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace('{location}', parsedArgs.location.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Site\DeleteLocationBySiteIdController::undo
* @see app/Http/Controllers/Site/DeleteLocationBySiteIdController.php
* @route '/api/site/undo-delete/{site}/{location}'
*/
undo.delete = (args: { site: string | number | { id: string | number }, location: string | number } | [site: string | number | { id: string | number }, location: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: undo.url(args, options),
    method: 'delete',
})

const DeleteLocationBySiteIdController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteLocationBySiteIdController